import Catalyst from '@Services/Catalyst';
import { getProjectRouteLevelContent, getStepLevelContent } from '@Pages/RetroSynthesis/ProjectRoute/analytics';
import { RouteType, getProjectDetail, getProjectType } from '@Pages/RetroSynthesis/constants';

export const onAddStepDialogOpen = ({ projectId, routeId, stepNumber, routeType, projectInfo }) => {
  Catalyst.trackEvent('contentAdditionStart', {
    content: [
      ...getProjectRouteLevelContent({ projectId, routeId, routeType, projectInfo }),
      getStepLevelContent({ projectId, routeId, stepNumber }),
    ],
  });
};

export const onAddSteps = ({ projectId, routeId, routeType, predictedCount, publishedCount, inHouseCount, projectInfo }) => {
  Catalyst.trackEvent('contentAddition', {
    content: [
      {
        id: `project:${projectId}`, // example value, unique project identifier
        detail: getProjectDetail({ ...projectInfo, id: projectId }),
        type: `${getProjectType(projectInfo)}:project:predicted(${predictedCount}):published(${publishedCount}):in-house(${inHouseCount})`, // e.g. project:predicted(20):published(5):in-house(2)
      },
      {
        id: `project:${projectId}`,
        id2: `route:${routeId}`,
        type: routeType ? RouteType.trackingMap[routeType] : '',
      },
    ],
  });
};
